import { Helmet } from "react-helmet";

export default function Canonical({ url }) {
  return (
    <Helmet>
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
